<template lang="pug">
  a.FooterDonation(v-if="settings" :class="classObject" :href="settings.donation_link.url")
    | {{ settings.donation_link.title }}
    SvgInline(src="extern")
</template>

<script>

import { mapGetters } from 'vuex'
import SvgInline from '@/components/SvgInline'

export default {
  props:
  {
    theme: {
      style: String,
      required: true,
      validator: (value) => {
        return ['light', 'dark'].indexOf(value) !== -1
      }
    },
    borders: Boolean
  },
  data () {
    return {}
  },
  components: {
    SvgInline
  },
  computed: {
    ...mapGetters(['settings']),
    classObject: function () {
      return {
        [`FooterDonation-${this.theme}`]: true,
        [`FooterDonation-borders`]: this.borders
      }
    }
  }
}

</script>

<style lang="stylus" scope>
.FooterDonation
  position absolute
  bottom 20px
  right 10px
  padding 10px 15px
  text-decoration none
  text-transform uppercase
  font-weight 600
  font-size: 10px;
  letter-spacing: 2px;
  text-align: center;
  display inline-block
  transition color 0.8s $ease, border-color 0.8s $ease, background-color 0.8s $ease, transform 1s $ease, opacity 0.8s $ease

  &:hover

    transform scale(0.98)
    opacity 0.5

  @media $mq_m
    bottom 42px
    right 20px

  @media $mq_l
    bottom 50px
    right 50px
    padding 15px 35px
    font-size: 14px;

  svg
    width 10px
    height 10px
    transition all 0.6s $ease
    margin-left 10px

    @media $mq_l
      width 15px
      height 15px

  &-borders
    border 1px solid currentColor
    border-radius 50px

  &-dark
    color: $black

  &-light
    color: $beige

</style>
